import React, { useState, useEffect } from "react";
import rightArrow from "../../../../assets/images/homepage/setting/ManageUser/rightArrow.svg";
import rightArrowDark from "../../../../assets/images/homepage/setting/ManageUser/rightArrowDark.svg";
import "./manageTeam.scss";
import useTheme from "hooks/observer";
import nodata from "assets/images/homepage/setting/No data.svg";
import DeleteModal from "components/DeleteModal/index";
import TeamTable from "./teamTable/index";
import Team from "./Team/index";
import EditTeam from "./TeamEdit/index";
import EmptyTeam from "./emptyTeam/index";
import { Team as izTeam } from "@induz/sdk";
import { useToast } from "components/Toaster/index";

const initialTeams = [];


function ManageTeam({ setManageUser, searchQuery, setSearchQuery }) {
  const [teams, setTeams] = useState(initialTeams);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [selectedTeamIndex, setSelectedTeamIndex] = useState(null);
  const [teamToDelete, setTeamToDelete] = useState(null);
  
  const theme = useTheme();

  useEffect(() => {
      const fetchTeamsFromWasm = async () => {
        try {
          const teamNames = await izTeam.listTeams(); // Call exported WASM function
          const teams = teamNames.map((n) => ({
            roles: n.getName(),
            operations: n.getRoles(),
          }));

          
          setTeams(teams);
          
        } catch (error) {
          console.error("Error loading teams from WASM:", error);
        }
      };
  
      fetchTeamsFromWasm();
    }, [initialTeams]);

  const filteredTeams = teams.filter(
    (team) => {
      if (searchQuery === "") return true;
      return (
        team.roles.toLowerCase().includes(searchQuery.toLowerCase()) ||
        team.operations.some((operation) =>
          operation.toLowerCase().includes(searchQuery.toLowerCase())
        )
      );
    }
  );
  const showToast = useToast();

  // Register the add team handler with the homepage (similar to ManageUser)
  useEffect(() => {
    window.addTeamHandler = () => setIsModalOpen(true);
    
    // Cleanup on unmount
    return () => {
      window.addTeamHandler = null;
    };
  }, []);

  const handleshowDelete = (teamIndex) => {
    setTeamToDelete(teamIndex);
    setShowDelete(true);
  };

  const cancelShowDelete = () => {
    setShowDelete(false);
    setTeamToDelete(null);
  };

  const handleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const handleDelete = async () => {
    try{
    if (teamToDelete !== null) {
      await izTeam.removeTeam(teams[teamToDelete].roles);
      showToast("Team deleted successfully", "success");
      setTeams(teams.filter((_, index) => index !== teamToDelete));
      setTeamToDelete(null);
      setShowDelete(false);
    }
  } catch (error) {
    showToast("Failed to delete team", "error");
    console.error("Error deleting team:", error);
    setShowDelete(false);}
  };

  const handleEditTeam = (teamIndex) => {
    setSelectedTeamIndex(teamIndex);
    setEditModal(true);
  };

  const handleUpdateTeam = (updatedTeam) => {
    setTeams((prev) =>
      prev.map((team, index) =>
        index === selectedTeamIndex ? updatedTeam : team
      )
    );
    setEditModal(false);
  };

  const handleAddRole = (newRole) => {
    setTeams((prev) => [...prev, newRole]);
  };

  return (
    <div
      className={`ManageTeam ${teams.length < 0 || isModalOpen || editModal ? "ManageTeamEmpty" : ""}`}
    >
      <div className="manageUserHeader">
        <p onClick={() => setManageUser("")} style={{ cursor: "pointer" }}>
          Settings
        </p>
        <img
          src={theme === "light" ? rightArrow : rightArrowDark}
          alt="arrow"
        />
        <p className="user">Manage Teams</p>
      </div>
      <div className="title">
        {/* <p>Manage Team</p> */}
      </div>
      <div className="searchBox">
        {/* Search bar and Add Team button moved to homepage header */}
      </div>

      {isModalOpen && (
        <Team handleCancel={handleModal} onAddRole={handleAddRole} />
      )}

      {editModal && (
        <EditTeam
          handleCancel={() => setEditModal(false)}
          onUpdateTeam={handleUpdateTeam}
          team={teams[selectedTeamIndex]}
        />
      )}

      {showDelete && (
        <DeleteModal
          handleCancel={cancelShowDelete}
          title={
            <>
              Are you sure you want to delete the team{" "}
              <span
                style={{
                  fontWeight: 700,  
                  color: "#9B2FAB",        
                  fontSize: "1.25rem",      
                  lineHeight: 1.2,          
                }}
              >
                {teams[teamToDelete]?.roles}
              </span>{" "}
              permanently?
            </>
          }
          handleSave={handleDelete}
          mockClass={"manage"}
        />
      )}

      {filteredTeams.length === 0 && teams.length > 0 ? (
        <div className="noResults">
          <img src={nodata} alt="no data" />
          <p className="text">No Data Found</p>
        </div>
      ) : teams.length >= 0 ? (
        <TeamTable
          handleDelete={handleDelete}
          handleshowDelete={handleshowDelete}
          teams={filteredTeams}
          handleEditTeam={handleEditTeam}
        />
      ) : (
        <EmptyTeam handleModal={handleModal} />
      )}
    </div>
  );
}

export default ManageTeam;